import { Link } from '@tanstack/react-router';

/**
 * Permission denied page.
 *
 * Shown when `requirePermission` blocks a route. It is an honest "you cannot do
 * this here" screen rather than a partially-populated page whose every action
 * fails. Links back to the dashboard so the operator can recover.
 */
export function DeniedPage() {
  return (
    <main className="min-h-screen flex items-center justify-center bg-surface px-4">
      <div className="max-w-md space-y-4">
        <h1 className="text-2xl font-bold text-content">You don't have permission</h1>
        <p className="text-content-muted">
          Your session does not include the permission required for this page.
        </p>
        <p className="text-sm text-content-muted/60">
          This is a UX affordance only — the server re-authorizes every request.
        </p>
        <Link
          to="/overview"
          className="inline-flex items-center gap-2 text-accent underline-offset-4 hover:underline"
        >
          <span>Back to dashboard</span>
        </Link>
      </div>
    </main>
  );
}
